/**
 * 全屏加载遮罩层 - AI 智能风格
 */
import React from 'react';

interface LoadingOverlayProps {
  show: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  show, 
  message = '正在加载项目数据...' 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/10 backdrop-blur-[2px]">
      <div className="relative">
        {/* 外圈旋转光环 */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-32 h-32 border-4 border-transparent border-t-blue-500 border-r-purple-500 rounded-full animate-spin"></div>
        </div>
        
        {/* 中圈反向旋转光环 */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-24 h-24 border-4 border-transparent border-b-pink-500 border-l-indigo-500 rounded-full animate-spin-slow"></div>
        </div>
        
        {/* 占位空间 */}
        <div className="w-32"></div>
        
        {/* 加载文字 - 在双环下方，部分压盖双环底部 */}
        <div className="absolute top-20 left-1/2 transform -translate-x-1/2">
          <div className="bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg whitespace-nowrap">
            <p className="text-base font-medium text-gray-700 mb-1">
              {message}
            </p>
            <div className="flex items-center justify-center space-x-1">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-2 h-2 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
